import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const DashboardContext = createContext(null);

/**
 * Fetches /api/dashboard on mount + on-demand and exposes it to child pages
 * (e.g. the Reviews badge in the sidebar, the Dashboard page itself).
 */
export function DashboardProvider({ children }) {
    const { status } = useAuth();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const refresh = useCallback(async () => {
        if (status !== "authenticated") return null;
        setLoading(true);
        try {
            const { data } = await api.get("/dashboard");
            setData(data);
            return data;
        } catch {
            return null;
        } finally {
            setLoading(false);
        }
    }, [status]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <DashboardContext.Provider value={{ data, loading, refresh }}>
            {children}
        </DashboardContext.Provider>
    );
}

export function useDashboard() {
    return useContext(DashboardContext) || { data: null, loading: false, refresh: async () => null };
}
